export default {
  "explore environment": "สำรวจสิ่งแวดล้อม",
  "choose strategy": "เลือกกลวิธี",
  "justify": "ให้เหตุผลสนับสนุน",
  "make inferences": "อนุมาน",
  "run trial": "ทดลองทำ",
  "compare effects": "เปรียบเทียบผล",
  "note results": "จดบันทึกผล",
  "difficulty": "ระดับความยาก",
  "easy": "ระดับง่าย",
  "intermediate": "ระดับกลาง",
  "difficult": "ระดับยาก",
  "linguistics": "ภาษาศาสตร์",
  "reading": "การอ่าน",
  "listening": "การฟัง",
  "speaking": "กำลังพูด",
  "writing": "การเขียน",
  "conditionals": "เงื่อนไข",
  "modularity": "การแยกเป็นโมดูล",
  "creation and destruction": "การสร้าง & การทำลาย",
  "repetition": "การทำซ้ำ",
  "computational problem solving": "การแก้ปัญหาที่อาศัยการคิดคำนวน",
  "self regulated learning": "การเรียนรู้ที่อาศัยการควบคุมตนเอง",
  "evaluate own performance": "ประเมินผลการปฏิบัติของตัวเอง",
  "use resources": "ใช้ทรัพยากร",
  "stay engaged": "ยังจดจ่ออยู่",
  "adapt to feedback": "ปรับตามข้อคิดเห็น",
  "visit": "เข้าชม",
  "units of measurement": "หน่วยการวัด",
  "area perimeter and volume": "พื้นที่, เส้นรอบวง และปริมาตร",
  "whole numbers": "จำนวนเต็ม",
  "expressions and equations": "นิพจน์และสมการ",
  "fractions and decimals": "เศษส่วนและเลขทศนิยม",
  "scientific inquiry": "การสืบค้นทางวิทยาศาสตร์",
  "processes": "กรอบการประเมินทักษะการรู้คิด",
  "content areas": "ขอบเขตเนื้อหา",
  "behaviour": "พฤติกรรม",
  "skill": "ทักษะ",
  "tinker": "ปรับปรุง",
  "controlled test": "ทดสอบ",
  "design": "ออกแบบ",
  "record": "บันทึกผลลัพธ์",
  "conclude": "การสรุปผล",
  "math reasoning": "การให้เหตุผลทางคณิตศาสตร์",
  "compute": "คำนวณ",
  "addition": "บวก",
  "subtraction": "ลบ",
  "multiplication": "คูณ",
  "division": "หาร",
  "comparison": "การเปรียบเทียบ",
  "conversion of volume": "การแปลงหน่วยปริมาตร",
  "perimeter": "เส้นรอบรูป",
  "general": "ทั่วไป",
  "attempts": "ลองใหม่",
  "not started": "ยังไม่ได้เริ่ม",
  "game": "เกม",
  "test": "ทดสอบ",
  "observe": "สังเกต",
  "infer": "สรุปความหมาย",
  "explain": "อธิบาย",
  "compare": "เปรียบเทียบ",
  "experiment": "การทดลอง",
  "hypothesise": "การตั้งสมมติฐาน",
  "analyse": "การวิเคราะห์",
  "equation": "สมการ",
  "deploy": "การนำไปใช้",
  "implement": "การลงมือปฏิบัติ",
  "area": "พื้นที่",
  "strategise": "การวางกลยุทธ์",
  "strategize": "การวางกลยุทธ์",
  "adapt": "การปรับตัว",
  "adjust": "การปรับเปลี่ยน",
  "explain student dashboard": "อธิบายแดชบอร์ดของนักเรียน",
  "student dashboard": "แดชบอร์ดของนักเรียน",
  "student": "นักเรียน",
  "strategize garden": "การวางแผนสวนเชิงกลยุทธ์",
  "summary": "สรุป",
  "hide details": "ซ่อนรายละเอียด",
  "show details": "แสดงรายละเอียด",
  "generalize": "สรุปเป็นหลักการทั่วไป",
  "review": "ทบทวน",
  "if the student has played the game multiple times, this dashboard displays their best result. the dashboard updates after they finish playing a game.": "หากนักเรียนเล่นเกมหลายครั้ง แดชบอร์ดนี้จะแสดงผลลัพธ์ที่ดีที่สุดของนักเรียน แดชบอร์ดจะอัปเดตหลังจากนักเรียนเล่นเกมเสร็จ"
}
